"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectType = exports.MapLayer = exports.MapTilesetLayer = exports.TilesWithNoFOVUpdate = void 0;
// tiles that show as clear and forcibly overwrite FOV when on a dense tile
var TilesWithNoFOVUpdate;
(function (TilesWithNoFOVUpdate) {
    TilesWithNoFOVUpdate[TilesWithNoFOVUpdate["Empty"] = 0] = "Empty";
    TilesWithNoFOVUpdate[TilesWithNoFOVUpdate["Air"] = 2386] = "Air";
})(TilesWithNoFOVUpdate || (exports.TilesWithNoFOVUpdate = TilesWithNoFOVUpdate = {}));
var MapTilesetLayer;
(function (MapTilesetLayer) {
    MapTilesetLayer[MapTilesetLayer["Terrain"] = 0] = "Terrain";
    MapTilesetLayer[MapTilesetLayer["Walls"] = 1] = "Walls";
    MapTilesetLayer[MapTilesetLayer["Decor"] = 2] = "Decor";
    MapTilesetLayer[MapTilesetLayer["Creatures"] = 3] = "Creatures";
})(MapTilesetLayer || (exports.MapTilesetLayer = MapTilesetLayer = {}));
// layers for the map, in order
var MapLayer;
(function (MapLayer) {
    MapLayer[MapLayer["Terrain"] = 0] = "Terrain";
    MapLayer[MapLayer["Floors"] = 1] = "Floors";
    MapLayer[MapLayer["Fluids"] = 2] = "Fluids";
    MapLayer[MapLayer["Foliage"] = 3] = "Foliage";
    MapLayer[MapLayer["Walls"] = 4] = "Walls";
    MapLayer[MapLayer["Decor"] = 5] = "Decor";
    MapLayer[MapLayer["DenseDecor"] = 6] = "DenseDecor";
    MapLayer[MapLayer["OpaqueDecor"] = 7] = "OpaqueDecor";
    MapLayer[MapLayer["Interactables"] = 8] = "Interactables";
    MapLayer[MapLayer["NPCs"] = 9] = "NPCs";
    MapLayer[MapLayer["Spawners"] = 10] = "Spawners";
    MapLayer[MapLayer["RegionDescriptions"] = 11] = "RegionDescriptions";
    MapLayer[MapLayer["BackgroundMusic"] = 12] = "BackgroundMusic";
    MapLayer[MapLayer["Succorport"] = 13] = "Succorport";
    MapLayer[MapLayer["SpawnerZones"] = 14] = "SpawnerZones";
    MapLayer[MapLayer["ZLevel"] = 15] = "ZLevel";
})(MapLayer || (exports.MapLayer = MapLayer = {}));
// types of interactables and other objects present on a map
var ObjectType;
(function (ObjectType) {
    ObjectType["Door"] = "Door";
    ObjectType["SecretWall"] = "SecretWall";
    ObjectType["Locker"] = "Locker";
    ObjectType["StairsUp"] = "StairsUp";
    ObjectType["StairsDown"] = "StairsDown";
    ObjectType["ClimbUp"] = "ClimbUp";
    ObjectType["ClimbDown"] = "ClimbDown";
    ObjectType["Fall"] = "Fall";
    ObjectType["Teleport"] = "Teleport";
    ObjectType["Fillable"] = "Fillable";
    ObjectType["EventSource"] = "EventSource";
    ObjectType["TreasureChest"] = "TreasureChest";
    ObjectType["PassableWall"] = "PassableWall";
})(ObjectType || (exports.ObjectType = ObjectType = {}));
